import { http } from "@/utils/request";

/**
 * 获取公司治理列表
 */
export const useGetGovernmentListApi = async (params) => {
  console.log("公司治理接口-请求参数", params);
  const res = await http.post("/companyOfficialWebsite/siteGvmtListForOut", params);
  console.log("公司治理接口-返回数据", res);
  return res;
};

/**
 * 获取公司治理列表
 */
export const useGetChartListApi = async (params) => {
  console.log("公司章程接口-请求参数", params);
  const res = await http.post("/companyOfficialWebsite/siteRuleListForOut", params);
  console.log("公司章程接口-返回数据", res);
  return res;
};
